export default "__VITE_ASSET__B4P8TC8h__"